import difference from 'lodash/difference';
import without from 'lodash/without';
import { defaultSorting } from '../constants/ioc';

export const isDefaultFilter = ({ filters, sorting }) => {
  return (
    (!filters.type || filters.type.length === 0) &&
    (!filters.feed || filters.feed.length === 0) &&
    sorting.total === defaultSorting.total &&
    (!sorting.totalCustom ||
      sorting.totalCustom === defaultSorting.totalCustom) &&
    (!sorting.totalIoc || sorting.totalIoc === defaultSorting.totalIoc) &&
    (!sorting.totalSourceScore ||
      sorting.totalSourceScore === defaultSorting.totalSourceScore)
  );
};

export const updateSortOrder = (newSorting, oldSorting) => {
  const newSortingValues = Object.values(newSorting).filter((v) => v);
  const oldSortingValues = Object.values(oldSorting).filter((v) => v);

  const itemsToAdd = difference(newSortingValues, oldSortingValues);
  const itemsToRemove = difference(oldSortingValues, newSortingValues);

  let res = newSortingValues;
  //  let res = without(oldSortingValues, ...itemsToRemove);
  //  res = [...res, ...itemsToAdd];

  return res;
};
